<mat-toolbar class="toolbar ac-flex ac-gap-sm">
  <div
    class="logo ac-flex ac-algn-ctr ac-gap-xs"
    [class.logged-in]="!!user()">
    <div
      class="logo-container ac-flex ac-algn-ctr ac-gap-sm"
      routerLink="/"
      (click)="shell.closeSidenavs()">
      <ac-icon
        iconKey="brand:gains_filled"
        [size]="showWordmark() ? 28 : 32"
        class="filled-icon" />
      @if (showWordmark()) {
        <ac-icon iconKey="brand:gains_text" [size]="132" [useWidth]="true" />
      }
    </div>
  </div>

  @if (actionsLoading()) {
    <div class="wallet-loading ac-flex ac-ctr" [class.logged-in]="!!user()">
      <ac-loading [size]="30" />
    </div>
  } @else if (user()) {
    <div class="finance-content ac-flex ac-algn-ctr ac-gap-sm">
      @if (device.gtSmScreen()) {
        <button
          mat-flat-button
          class="wallet-btn"
          type="button"
          (click)="walletDialog.openWalletModal()">
          <ac-icon iconKey="hr:wallet" />
          Wallet
        </button>
      }

      <div class="curve-container">
        @if (device.gtXsScreen()) {
          <svg
            class="curve"
            width="398"
            height="74"
            viewBox="0 0 398 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M281.954 73.5H117.541C106.178 73.5 95.79 67.0799 90.7082 56.9164L77.8355 31.1711C70.1573 15.8146 55.1369 5.4716 38.0518 3.77613L0 0H397.5L360.711 3.67893C343.212 5.42878 327.92 16.2426 320.437 32.1572L309.103 56.2642C304.157 66.7842 293.579 73.5 281.954 73.5Z"
              fill="currentColor"
            />
          </svg>
        }

        @if (merchView.merchExperience()) {
          <div class="wallet toggle-button sc-only ac-flex ac-algn-ctr ac-gap-sm">
            <div class="toggle-indicator sc"></div>

            <div class="sc-toggle selected ac-flex ac-algn-ctr">
              <app-sc-icon [size]="30" />

              <span class="balance-amount ac-title-md">
                {{userState()!.shown_balance_sc | decimal : 2 }}
              </span>
            </div>
          </div>
        } @else if (!deviceModeView.sweepsVisible()) {
          <div class="wallet toggle-button gc-only ac-flex ac-algn-ctr ac-gap-sm">
            <div class="toggle-indicator gc"></div>

            <div class="gc-toggle selected ac-flex ac-algn-ctr">
              <span class="balance-amount ac-title-md">
                {{userState()!.shown_balance_gc | decimal : 2 }}
              </span>

              <app-gc-icon [size]="30" />
            </div>
          </div>
        } @else {
          <button
            class="wallet toggle-button ac-flex ac-algn-ctr ac-gap-sm"
            (click)="
              balanceView.saveSelectedBalanceType(
                sweepsCoinsSelected() === 'sweeps_coins'
                  ? 'gold_coins'
                  : 'sweeps_coins'
              )">
            <div
              class="toggle-indicator"
              [class.sc]="sweepsCoinsSelected() === 'sweeps_coins'"
              [class.gc]="sweepsCoinsSelected() === 'gold_coins'">
            </div>

            <div
              class="sc-toggle ac-flex ac-algn-ctr"
              [class.selected]="sweepsCoinsSelected() === 'sweeps_coins'">
              <app-sc-icon [size]="30" />

              <span class="balance-amount ac-title-md">
                {{userState()!.shown_balance_sc | decimal : 2 }}
              </span>
            </div>

            <div
              class="gc-toggle ac-flex ac-algn-ctr"
              [class.selected]="sweepsCoinsSelected() === 'gold_coins'">
              <span class="balance-amount ac-title-md">
                {{userState()!.shown_balance_gc | decimal : 2 }}
              </span>
              <app-gc-icon [size]="30" />
            </div>
          </button>
        }
      </div>

      @if (device.gtSmScreen()) {
        @if (merchView.merchExperience()) {
          <button
            mat-button
            class="shop-btn shop-btn-large"
            type="button"
            (authClick)="goToShop()"
            [enforceTimeout]="true"
            [enforceRegion]="true">
            <img src="images/merch_bag_3d.webp" alt="" width="24" height="24" />
            Shop
          </button>
        } @else if (deviceModeView.buyCoinsVisible()) {
          <button
            mat-button
            class="buy-coins-btn buy-coins-btn-large"
            type="button"
            [disabled]="deviceModeView.purchaseCapReached()"
            [matTooltip]="purchaseCapMessage"
            [matTooltipDisabled]="!deviceModeView.purchaseCapReached()"
            [disabledInteractive]="true"
            (authClick)="!deviceModeView.purchaseCapReached() && walletDialog.openPurchaseModal()"
            [enforceTimeout]="true"
            [enforceRegion]="true">
            @if (device.gtSmScreen()) {
              <app-gc-icon type="3d" />
            } Buy Coins
          </button>
        } @else {
          <app-region-restricted-notice />
        }
      }
    </div>

    @if (device.gtXsScreen()) {
      <div class="ac-flex authed-actions">
        @if (device.isSmScreen()) {
          @if (merchView.merchExperience()) {
            <button
              mat-icon-button
              class="shop-btn"
              type="button"
              (authClick)="goToShop()"
              [enforceTimeout]="true"
              [enforceRegion]="true">
              <img src="images/merch_bag_3d.webp" alt="Shop" width="24" height="24" />
            </button>
          } @else if (deviceModeView.buyCoinsVisible()) {
            <button
              mat-icon-button
              class="buy-coins-btn"
              type="button"
              [disabled]="deviceModeView.purchaseCapReached()"
              [matTooltip]="purchaseCapMessage"
              [matTooltipDisabled]="!deviceModeView.purchaseCapReached()"
              [disabledInteractive]="true"
              (click)="!deviceModeView.purchaseCapReached() && walletDialog.openPurchaseModal()">
              <app-gc-icon type="3d" />
            </button>
          }
        }

        <button
          mat-icon-button
          class="menu-btn avatar-menu"
          [matMenuTriggerFor]="menu">
          <img
            [src]="
              userState()?.avatar_url ??
              ('cdnUrl' | env) + '/images/default_avatar.webp'
            "
            alt="user-avatar"
          />
        </button>

        <mat-menu #menu="matMenu">
          @if (userState()) {
            <div class="user-info ac-pd-lg" (click)="$event.stopPropagation()">
              <app-user-avatar [user]="userAvatarVM()" />
            </div>
          }

          <button mat-menu-item routerLink="/settings/profile">
            <div class="menu-item-label ac-flex ac-gap-sm ac-algn-ctr">
              <div class="menu-icon ac-flex ac-ctr">
                <ac-icon iconKey="hr:settings" />
              </div>
              Settings
            </div>
          </button>
          @if (device.ltMdScreen()) {
            <button mat-menu-item (click)="walletDialog.openWalletModal()">
              <div class="menu-item-label ac-flex ac-gap-sm ac-algn-ctr">
                <div class="menu-icon ac-flex ac-ctr">
                  <ac-icon iconKey="hr:wallet" />
                </div>
                Wallet
              </div>
            </button>
          }
          <button mat-menu-item routerLink="/transactions">
            <div class="menu-item-label ac-flex ac-gap-sm ac-algn-ctr">
              <div class="menu-icon ac-flex ac-ctr">
                <ac-icon iconKey="hr:transactions" />
              </div>
              Transactions
            </div>
          </button>
          @if (merchView.merchExperience()) {
            <button mat-menu-item routerLink="/shop/orders">
              <div class="menu-item-label ac-flex ac-gap-sm ac-algn-ctr">
                <div class="menu-icon ac-flex ac-ctr">
                  <ac-icon iconKey="hr:package" />
                </div>
                Orders
              </div>
            </button>
          }
          <button mat-menu-item (click)="signOut()">
            <div class="menu-item-label ac-flex ac-gap-sm ac-algn-ctr">
              <div class="menu-icon ac-flex ac-ctr">
                <ac-icon iconKey="hr:sign_out" />
              </div>
              Sign Out
            </div>
          </button>

          <div
            class="invite-friends ac-flex-col ac-gap-sm ac-pd-md-lg ac-algn-strt"
            (click)="$event.stopPropagation()">
            <img
              ngSrc="{{ 'cdnUrl' | env }}/images/referrals/refer_a_friend.webp"
              [height]="24"
              [width]="24"
              alt="referral icon"
            />
            <div class="ac-title-md">Invite friends, get rewards</div>
            <div class="ac-body-sm ac-label">
              Earn
              {{ metadata.referralsConfig()?.referrer_sc_bonus | decimal : 0 }} SC +
              {{ metadata.referralsConfig()?.referrer_gc_bonus | decimal : 0 }} GC
              for every friend you refer!
            </div>
            <a class="ac-link" routerLink="/referrals" (click)="menu.closed.emit()">
              Invite Now
            </a>
          </div>
        </mat-menu>
      </div>
    } @else if (device.isXsScreen()) {
      <div class="xs-actions ac-flex ac-algn-ctr">
        @if (merchView.merchExperience()) {
          <button
            mat-button
            class="shop-btn"
            type="button"
            (authClick)="goToShop()"
            [enforceTimeout]="true"
            [enforceRegion]="true">
            <img src="images/merch_bag_3d.webp" alt="" width="20" height="20" />
            Shop
          </button>
        } @else if (deviceModeView.buyCoinsVisible()) {
          <button
            mat-button
            class="buy-coins-btn"
            type="button"
            [disabled]="deviceModeView.purchaseCapReached()"
            [matTooltip]="purchaseCapMessage"
            [matTooltipDisabled]="!deviceModeView.purchaseCapReached()"
            [disabledInteractive]="true"
            (authClick)="!deviceModeView.purchaseCapReached() && walletDialog.openPurchaseModal()"
            [enforceTimeout]="true"
            [enforceRegion]="true">
            <app-gc-icon type="3d" [size]="20" />
            Buy Coins
          </button>
        }
      </div>
    }
  } @else if (device.gtXsScreen() && !device.isMobilePlatform && (!!device.properties || platform.isBrowser)) {
    <div class="login-actions ac-flex ac-gap-sm">
      <button mat-flat-button class="ac-neutral" (click)="openAuthDialog()">
        Login
      </button>
      <button mat-flat-button (click)="openAuthDialog('signup')">Sign Up</button>
    </div>
  }
</mat-toolbar>
